import { createSelector, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "./store";
import Cookies from "js-cookie";

const initialState = {
  loggedInUser: null,
  authenticated: false,
  tokenData: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.loggedInUser = action.payload;
    },
    setAuthenticated: (state, action) => {
      state.authenticated = action.payload;
    },
    setTokenData: (state, action) => {
      state.tokenData = action.payload;
    },
  },
});

export const logInUser = (loginData: any) => {
  return async (dispatch: any, getState: any) => {
    const { loggedInUser, authenticated, token } = loginData;
    dispatch(setUser(loggedInUser));
    dispatch(setAuthenticated(authenticated));
    const { tokenExpiryDate } = loggedInUser;
    dispatch(
      setTokenData({
        token,
        tokenExpiryDate,
      })
    );
    Cookies.set("token", token, {});
    Cookies.set("tokenExpiryDate", tokenExpiryDate, {});
  };
};

export const logTempToken = (tokenData: any) => {
  return async (dispatch: any, getState: any) => {
    const { tokenExpiryDate, token } = tokenData;
    dispatch(setUser(null));
    dispatch(setAuthenticated(false));
    dispatch(
      setTokenData({
        token,
        tokenExpiryDate,
      })
    );
    Cookies.set("token", token, {});
    Cookies.set("tokenExpiryDate", tokenExpiryDate, {});
  };
};

export const logOutUser = () => {
  return async (dispatch: any, getState: any) => {
    dispatch(setUser(null));
    dispatch(setAuthenticated(false));
    dispatch(setTokenData(null));
    Cookies.remove("token");
    Cookies.remove("tokenExpiryDate");
  };
};

const emptyTokenData = {
  token: null,
  tokenExpiryDate: null,
};

export const getActiveUser = createSelector(
  [
    (state: RootState) => state.auth.loggedInUser,
    (state: RootState) => state.auth.authenticated,
    (state: RootState) => state.auth.tokenData,
    (_state: RootState, loggedInUser: any = null) => loggedInUser,
  ],
  (stateLoggedInUser, authenticated, tokenData, loggedInUser) => {
    const fallbackTokenData = loggedInUser?.token
      ? {
          token: loggedInUser.token,
          tokenExpiryDate: loggedInUser.tokenExpiryDate || null,
        }
      : emptyTokenData;

    return {
      loggedInUser: stateLoggedInUser || loggedInUser || null,
      authenticated: !!(authenticated || loggedInUser?.token),
      tokenData: tokenData || fallbackTokenData,
    };
  },
);

export const { setUser, setAuthenticated, setTokenData } = authSlice.actions;
export default authSlice.reducer;
